import { z } from 'zod';
import { MEMBER_MIGRATION_STATUS } from './schema';

// ─── Pelago 1 read-only rule ─────────────────────────────────────────────────
//
// The one definition of "this member's Pelago 1 record must not be edited any
// more". backend2 is frozen for a member from the moment their migration
// STARTS, so `running` already counts, not only `done`. `failed` deliberately
// does not: a failed migration hands the member back to Pelago 1. Neither does
// `pending`, which only means a Pelago 2 account exists — the member has not
// switched — so the existence of a marker is never the signal.
//
// `none` is the absence of any marker (or of any Galapagos member at all): the
// common case for a Pelago 1 member, and editable.

export const MEMBER_MIGRATION_STATUS_OR_NONE = ['none', ...MEMBER_MIGRATION_STATUS] as const;
export const memberMigrationStatusOrNoneSchema = z.enum(MEMBER_MIGRATION_STATUS_OR_NONE);
export type MemberMigrationStatusOrNone = z.infer<typeof memberMigrationStatusOrNoneSchema>;

const READ_ONLY_STATUSES: ReadonlySet<MemberMigrationStatusOrNone> = new Set(['running', 'done']);

export function isPelago1ReadOnly(status: MemberMigrationStatusOrNone): boolean {
  return READ_ONLY_STATUSES.has(status);
}
